import { CustomAbsolutePositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import { Theme } from "../../Theme";

export default function DefaultDropdownMenu({
    setValue,
    values,
    onClose,
    top,
    left,
    minWidth,
    borderRadius,
    openedLeftSide,
    padding,
}) {
    const applyValue = (value) => {
        setValue(value);
        onClose();
    };

    return (
        <CustomAbsolutePositionDropdownWrapper
            padding={padding}
            top={top}
            left={left}
            minWidth={minWidth}
            borderRadius={borderRadius}
            openedLeftSide={openedLeftSide}
        >
            {values.map((v) => (
                <SizedBox
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.neutral100}
                    padding={"0 10px"}
                >
                    <Row
                        key={v.value}
                        justifyContent={"space-between"}
                        padding={"10px 10px"}
                        cursor={"pointer"}
                        onClick={() => applyValue(v.value)}
                        width={"100%"}
                    >
                        <C3Text fontColor={Theme.color.zinc850}>{v.label}</C3Text>
                    </Row>
                </SizedBox>
            ))}
        </CustomAbsolutePositionDropdownWrapper>
    );
}
